import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { PropertyDetailsResponse } from '../../api/bridgingFinance/getPropertyDetails'

export type FullTitleProperty = {
  cmaid: number
  erfNo: string
  address: string
  suburb: string
  municipalityName: string
}

export type SectionalTitleProperty = {
  sectionNo: number
  schemeNo: number
  schemeName: string
  address: string
  suburb: string
  municipalityName: string
}

export interface SelectedPropertyState {
  selectedProperty?: PropertyDetailsResponse
  isShowingSalesDetails: boolean
  addProperty: (property: PropertyDetailsResponse) => void
  showSalesDetails: () => void
  hideSalesDetails: () => void
  clear: () => void
}

export const useSelectedProperty = create<SelectedPropertyState>()(
  devtools(
    persist(
      (set) => ({
        selectedProperty: undefined,
        isShowingSalesDetails: false,
        addProperty: (property: PropertyDetailsResponse) =>
          set((state) => ({
            selectedProperty: property,
            isShowingSalesDetails: false,
          })),
        showSalesDetails: () =>
          set((state) => ({ isShowingSalesDetails: true })),
        hideSalesDetails: () =>
          set((state) => ({ isShowingSalesDetails: false })),
        clear: () =>
          set((state) => ({
            sectionalTitleProperty: undefined,
            fullTitleProperty: undefined,
            owners: [],
            isShowingSalesDetails: false,
          })),
      }),
      {
        name: 'selectedProperty',
        getStorage: () => localStorage,
      },
    ),
  ),
)
